import React from 'react';

import { Container } from '@mui/material';

import classes from './NgzCustomerMealReportsTab.module.scss';
import { angularizeWithProviders } from '../../../../../shared/providers';
import { TabHeader } from './TabHeader/TabHeader';
import { MealInfoTable } from '../../../../components/MealInfoTable/MealInfoTable';
import { DailyMealTable } from '../../../../components/DailyMealTable/DailyMealTable';
import { EmptyList } from '../../../../../shared/components/ui-components';
import useMealReportsTabData from './hooks/useMealReportsTabData';

const NgzCustomerMealReportsTab = () => {
  const { mealReportsInfo, getAdaptedMealReports } = useMealReportsTabData();

  return (
    <Container className={classes.reportsTabContainer}>
      <TabHeader getAdaptedMealReports={getAdaptedMealReports} />
      {mealReportsInfo ? (
        <>
          {mealReportsInfo.mealReports.map((report) => (
            <MealInfoTable key={report.name} mealDetails={report} isReport />
          ))}
          <DailyMealTable dailyResult={mealReportsInfo.dailyResult} />
        </>
      ) : (
        <EmptyList show description="There is no meal report" />
      )}
    </Container>
  );
};

angularizeWithProviders(NgzCustomerMealReportsTab, 'ngzCustomerMealReportsTab', {});

export { NgzCustomerMealReportsTab };
